import Vue from 'vue';
import { getField, updateField } from 'vuex-map-fields';

import UploadFilesAPI from '../api/upload_files.js';

const getDefaultState = () => {
	return {
		filesArray: {},
		filesLoadStatus: 0,
		filesUploadStatus: 0,
		uploadProgress: {},
		uploadURL: '',
		type_id: null,
		project_id: null,
		status: {
			all: 1,
			filtered: 1,
			filteredPageChunk: 1,
			delete: 1,
			single: 1,
			add: 1,
			edit: 1,
			hiding: 1,
			unhiding: 1
		}
	};
};

export const uploadFiles = {
	strict: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state: getDefaultState(),

	actions: {
		async uploadFile({ commit, state, dispatch }, data) {
			if (!Object.keys(state.filesArray).length) return;
			const results = [];

			commit('setFilesUploadStatus', 1);
			for (var file in state.filesArray) {
				// skip loop if the property is from prototype
				// eslint-disable-next-line no-prototype-builtins
				if (!state.filesArray.hasOwnProperty(file)) continue;

				let formData = new FormData();
				var obj = state.filesArray[file];
				formData.append('file', obj.file);
				formData.append('type_id', state.type_id);
				formData.append('language_id', obj.lang_id);
				formData.append('language_code', obj.lang_code);
				formData.append('project_id', data.project_id);
				formData.append('project_hash_id', data.project_hash_id);
				formData.append('speaker_id', obj.speaker_id);

				commit('setUploadProgress', { lang_code: obj.lang_code, progress: 0 });
				// formData.append('upload_type', obj.upload_type);
				// console.log(formData['speaker_id']);
				// return (
				await UploadFilesAPI.postUploadFile(
					{ commit },
					state.uploadURL,
					formData,
					state.type_id,
					data.project_id
				)
					.then(
						function (response) {
							commit('setFilesUploadStatus', 2);

							Vue.SuccessSwal('File uploaded successfully. ' + response.data.filename);

							results.push(response);

							// console.log('⭐️🚀⭐️🚀 File upload done!', response.data.filename);
							// console.log('response: ', response);
							// console.log('response.data.language_id: ', response.data.language_id);
							// console.log('state: ', state);
							// console.log('state.uploadProgress: ', state.uploadProgress);
							// console.log(
							// 	'state.uploadProgress[response.data.language_id]: ',
							// 	state.uploadProgress[response.data.language_id]
							// );

							commit('removeFilesRow', response.data.language_id);

							return response;
						}.bind(this)
					)
					// eslint-disable-next-line no-loop-func
					.catch(function (data) {
						commit('setUploadProgress', { lang_code: obj.lang_code, progress: -100 });
						commit('setFilesUploadStatus', 3);
						Vue.CustomErrorSwal(
							data.response?.status,
							data.response?.statusText,
							data.response?.data.message
						);
						console.error(
							'💀💀 File upload failed! 💀💀\n👉 ' + obj.file.name + ' 👈',
							'\nerror:',
							data,
							'\nfile payload:',
							obj
						);
					});
				// );

				// for (var prop in obj) {
				// 	// skip loop if the property is from prototype
				// 	// eslint-disable-next-line no-prototype-builtins
				// 	if (!obj.hasOwnProperty(prop)) continue;

				// 	// your code
				// }
			}
			// console.log('❤️❤️❤️❤️ All uploads done!');
			return results;
		},
		uploadPoster({ commit, state, dispatch }, data) {
			// console.log('data: ', data);
			let formData = new FormData();
			formData.append('file', data.file);
			formData.append('type_id', data.type_id);
			formData.append('language_id', data.lang_id);
			formData.append('language_code', data.lang_code);
			formData.append('project_id', data.project_id);
			formData.append('project_hash_id', data.project_hash_id);
			// formData.append('upload_type', data.file.type);
			return UploadFilesAPI.postUploadFile({ commit }, data.uploadURL, formData, data.type_id, data.project_id)
				.then(
					function (response) {
						console.log('response: ', response);
						commit('setFilesUploadStatus', 2);
						// console.log('Response: ', response);
						// console.log('URL: ', response.data.path);
						return response;
					}.bind(this)
				)
				.catch(function (error) {
					commit('setFilesUploadStatus', 3);
					// console.log('Error: ', error);
					return error.response;
				});
		},

		deleteFile({ commit, state, dispatch }, id) {
			commit('setStatus', { type: 'delete', status: 1 });

			return UploadFilesAPI.deleteFile(id)
				.then(response => {
					// console.log(response.data);
					// console.log(response.status);
					// console.log(response.statusText);
					// console.log(response.headers);
					// console.log(response.config);
					return response;
				})
				.catch(function (error) {
					// if (error.response) {
					// 	// The request was made and the server responded with a status code
					// 	// that falls out of the range of 2xx
					// 	console.log(error.response);
					// 	console.log(error.response.data);
					// 	console.log(error.response.status);
					// 	console.log(error.response.headers);
					// 	console.log('Error:', error.message);
					// } else if (error.request) {
					// 	// The request was made but no response was received
					// 	// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
					// 	// http.ClientRequest in node.js
					// 	console.log(error.request);
					// } else {
					// 	// Something happened in setting up the request that triggered an Error
					// 	console.log('Error', error.message);
					// }
					// console.log(error.config);
					return error.response;
				});
		}
	},

	mutations: {
		resetState(state) {
			Object.assign(state, getDefaultState());
		},
		updateField,
		setStatus(state, payload) {
			state.status[payload.type] = payload.status;
		},
		addFilesRow(state, data) {
			Vue.set(state.filesArray, data.index, {
				lang_id: data.lang_id,
				lang_code: data.lang_code,
				file: data.file[0],
				upload_type: data.upload_type,
				speaker_id: data.speaker_id
				// file_name: data.file[0].name
			});
			state.uploadURL = data.upload_url;
			state.type_id = data.type_id;
			// console.log('upload_files store, current state:', JSON.stringify(state));
			// console.log(state.filesArray[data.index].file.type);
			// if (state.filesArray[data.index].file) {
			// 	console.log(data.index, state.filesArray[data.index].file.name);
			// }
		},
		removeFilesRow(state, langID) {
			// console.log('langID: ', langID);
			Vue.delete(state.filesArray, langID);
			// console.log(state);
		},
		setFilesUploadStatus(state, status) {
			state.filesUploadStatus = status;
		},
		setFiles(state, files) {
			state.files = files;
		},
		updateFileID(state, file) {
			// console.log('i: ' + file.i);
			// console.log('id: ' + file.id);
			state.files[file.i].id = file.id;
			state.files.splice(file.i, 1, state.files[file.i]);
			// console.log('file: ' + state.files[file.i].id);
		},
		removeUploadProgress(state, langCode) {
			Vue.delete(state.uploadProgress, langCode);
		},
		setUploadProgress(state, payload) {
			Vue.set(state.uploadProgress, payload.lang_code, payload.progress);
			// state.uploadProgress[payload.lang_code] = payload.progress;
		}
	},

	getters: {
		getField,
		getFilesUploadStatus(state) {
			return state.filesUploadStatus;
		},
		getUploadProgress(state) {
			return state.uploadProgress;
		},
		getFiles(state) {
			return state.files;
		},
		getFilesArray(state) {
			return state.filesArray;
		}
	}
};
